// extracted by mini-css-extract-plugin
export var container = "ReactivateCarousel_container__auObo";